import { ErrorComponentProps } from "@tanstack/react-router";
import { Button } from "./button";
import { AlertCircle, RotateCcw } from "lucide-react";

export function DefaultCatchBoundary({ error, reset }: ErrorComponentProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] p-8 text-center bg-surface rounded-xl m-4 border border-destructive/20">
      <div className="h-16 w-16 bg-destructive/10 rounded-full flex items-center justify-center mb-6">
        <AlertCircle className="h-8 w-8 text-destructive" />
      </div>
      <h2 className="text-2xl font-bold text-foreground mb-2">Oops! Something went wrong</h2>
      <p className="text-muted-foreground mb-6 max-w-md">
        We've encountered an unexpected error while loading this page. Our team has been notified.
      </p>

      {/* Show error details in development */}
      {process.env.NODE_ENV === "development" && (
        <div className="bg-destructive/10 text-destructive p-4 rounded-md text-sm text-left overflow-auto max-w-2xl w-full mb-6 whitespace-pre-wrap font-mono">
          {error.message}
          {error.stack && <div className="mt-2 text-xs opacity-70">{error.stack}</div>}
        </div>
      )}

      <div className="flex gap-4">
        <Button onClick={() => window.location.reload()} variant="outline">
          <RotateCcw className="me-2 h-4 w-4" />
          Reload Page
        </Button>
        <Button onClick={reset} className="bg-gradient-primary">
          Try Again
        </Button>
      </div>
    </div>
  );
}
